import { Box, CircularProgress, Stack, Typography } from "@mui/material";

interface FullScreenLoadingProps {
  /**
   * Optional message to display below the loading indicator.
   */
  message?: string;
}

/**
 * Full-screen loading component with the desplega.ai logo and a primary-colored circular progress indicator.
 */
export const FullScreenLoading = ({ message }: FullScreenLoadingProps) => {
  return (
    <Stack
      spacing={2}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "common.white",
        zIndex: 9999,
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src="/logo-blue.svg"
        alt="desplega.ai"
        sx={{
          width: 180,
          height: "auto",
          mb: 2,
        }}
      />

      {/* Circular Progress */}
      <CircularProgress
        size={48}
        thickness={4}
        sx={{
          color: "primary.main",
        }}
      />

      {/* Optional Message */}
      {message && (
        <Typography variant="h6" mt={2} align="center" color="text.secondary">
          {message}
        </Typography>
      )}
    </Stack>
  );
};
